import { useContext, useEffect, useRef } from "react";
import { AuthenticationContext } from "../../shared/providers/authentication/authentication.provider";
import { AnalyticsContext } from "../../shared/providers/analytics/analytics.provider";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";
import Button from "../Button/Button";

function LogoutDialog() {
    const { confirmLogout, setConfirmLogout, logoutUser, user } = useContext(AuthenticationContext);
    const { setEvent } = useContext(AnalyticsContext);
    const { translate } = useContext(TranslationContext);
    const logoutDialogRef = useRef<HTMLDialogElement>(null);

    useEffect(() => {
        if (confirmLogout) {
            logoutDialogRef.current?.showModal();

            logoutDialogRef.current?.addEventListener("keydown", (e: KeyboardEvent) => {
                if (e.key === "Escape") setConfirmLogout(false);
            });
        } else logoutDialogRef.current?.close();
    }, [confirmLogout, setConfirmLogout]);

    const handleLogout = async () => {
        setEvent({
            event_name: "app_logout",
            event_category: "auth",
            event_action: "app_logout",
            user_token: user?.id,
            company_id: user?.company.id,
        });
        await logoutUser();
    };

    if (!confirmLogout) return null;

    return (
        <dialog ref={logoutDialogRef} className="modal_logout py-31 px-22">
            <h2 className="text-h4-md mb-12 text-center">
                {translate("authentication.logout_confirm", "Are you sure you want to logout?")}
            </h2>
            <div className="d-flex gap-02">
                <Button
                    type="button"
                    onClick={handleLogout}
                    variant="solid"
                    customCss="w-100"
                    label={translate("common.confirm", "Confirm")}
                />
                <Button
                    type="button"
                    onClick={() => setConfirmLogout(false)}
                    variant="outlined"
                    customCss="w-100"
                    label={translate("common.cancel", "Cancel")}
                />
            </div>
        </dialog>
    );
}

export default LogoutDialog;
